/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{r as o,T as n,o as e}from"../chunks/index.js";import{findScriptDependencies as i}from"./treeAnalysis.js";function d(d,r=[]){const s=o(d);if(null===s.body||void 0===s.body)throw new n({index:0,line:0,column:0,data:null,description:"",code:e.InvalidExpression});return s.loadedModules={},i(s,r),s}export{d as parseScript};
